export function addProtocolToUrl(url: string) {
  if (!url.startsWith("http://") && !url.startsWith("https://")) {
    return "http://" + url;
  }
  return url;
}

export function convertToURLSearchParams(obj: object) {
  const params = new URLSearchParams();
  Object.entries(obj).forEach(([key, value]) => {
    if (value) {
      params.append(key, String(value));
    }
  });
  return params;
}
